var _style, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoCreative(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 197.5 45",
    style: {
      enableBackground: "new 0 0 197.5 45"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000025421401687523822440000001718427908561699518_);}\n\t.st1{fill:#201F1F;}\n\t.st2{fill:#40B59D;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 1.3,
    y: 4.9,
    width: 196,
    height: 34.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000127015421738251562150000001567975607101336766_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000127015421738251562150000001567975607101336766_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.7,29.2H37v6.5h-6.9V11.2h11.1c9.5,0,10.8,6.5,10.8,9c0,3.8-2,6.4-4.7,7.7l5.2,7.7h-7.3L40.7,29.2 L40.7,29.2z M45.1,20.3c0-1.1-0.4-2-1.1-2.7c-0.7-0.6-1.8-0.9-3.2-0.9H37v7.1h3.8c1.4,0,2.5-0.3,3.2-0.9 C44.7,22.3,45.1,21.4,45.1,20.3L45.1,20.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M64.6,4.9l-1.2,3.5h6.2l1.2-3.5H64.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.6,30.3v5.3H57.2V11.2h19v5.3H64v4.1h10.8v5.2H64v4.5H76.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3,30c-2.3-3.8-2.3-9.2,0-13.1c4.6-7.7,16.8-8.1,22-1.5l-4.4,4c-3.5-4.3-8-2.7-9.2-2 c-1.9,1.1-3.2,3.2-3.2,6.1c0,2.4,0.8,4.8,3.2,6.1c1.1,0.6,5.6,2.4,9.2-2l4.4,4C19.9,38,7.7,37.9,3,30z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M197.3,30.3v5.3h-19.5V11.2h19v5.3h-12.2v4.1h10.8v5.2h-10.8v4.5H197.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M172.7,11.2l-10.4,24.4h-6.8l-10.4-24.4h7.4l6.6,15.9l6.7-15.9H172.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M140.1,11.2h-6.9v24.4h6.9V11.2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.9,16.7h-7.4v-5.5h21.7v5.5h-7.4v18.9h-6.9V16.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.1,13.5l-3,8.7l1.3,3.2h-2.4l-1.8,5.3h6.3l2,4.9h7.4L99.1,13.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M91.9,4.9H98L85.9,39.7h-6.1L91.9,4.9z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCreative);
export default __webpack_public_path__ + "static/media/logo_creative.3a120c95651673d290b83434b061dcb3.svg";
export { ForwardRef as ReactComponent };